var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2190",
    d: "M1.08333 9.00001C1.08333 5.26806 1.08333 3.40208 2.2427 2.24271C3.40207 1.08334 5.26804 1.08334 8.99999 1.08334C12.7319 1.08334 14.5979 1.08334 15.7573 2.24271C16.9167 3.40208 16.9167 5.26806 16.9167 9.00001C16.9167 12.732 16.9167 14.5979 15.7573 15.7573C14.5979 16.9167 12.7319 16.9167 8.99999 16.9167C5.26804 16.9167 3.40207 16.9167 2.2427 15.7573C1.08333 14.5979 1.08333 12.732 1.08333 9.00001Z",
    fill: "white",
    stroke: "#97979A",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.ff9af116eda323e6cf66e2d5de5673f8.svg";
export { ForwardRef as ReactComponent };